export const AI_MESSAGES = {
  SOAP_UPDATE_DEFAULT: 'SOAPを更新しました。',
} as const
